// import Account from "./Account";
// import ForgotPassword from "../ForgotPassword";
// import ResetPassword from "../ResetPassword";
// import ActivateDayPass from "../ActivateDayPass";

import lazyImport from "../../../utils/lazyImport/lazyImport";

// lazyImport the above imports
const Account = lazyImport(() => import("./Account"));
const ForgotPassword = lazyImport(() => import("../ForgotPassword"));
const ResetPassword = lazyImport(() => import("../ResetPassword"));
const ActivateDayPass = lazyImport(() => import("../ActivateDayPass"));

export default {
  ActivateDayPass,
  ForgotPassword,
  ResetPassword,
  Account,
};
